module.exports = __webpack_public_path__ + "static/media/IMG_0771.b3931e5d.JPG";